import type { StorefrontSettings } from "@/types/product";

export type TemplateId = "grocery" | "sport-retail";

export type TemplatePreset = {
  id: TemplateId;
  name: string;
  tagline: string;
  primaryColor: string;
  backgroundColor: string;
  headerBackgroundColor: string;
  foregroundColor: string;
  font: "sans" | "serif" | "mono";
  cardSize: "small" | "medium" | "large";
  cardShowDescription: boolean;
  cardShowCategory: boolean;
  cardShowRating: boolean;
  cardShowSize: boolean;
  previewAccent: string;
  layoutStyle?: "standard" | "grocery" | "sport-retail";
};

export const TEMPLATES: TemplatePreset[] = [
  {
    id: "grocery",
    name: "Grocery",
    tagline: "Fresh & natural — ideal for food and produce",
    primaryColor: "#16a34a",
    backgroundColor: "#f0fdf4",
    headerBackgroundColor: "#14532d",
    foregroundColor: "#14532d",
    font: "sans",
    cardSize: "small",
    cardShowDescription: true,
    cardShowCategory: true,
    cardShowRating: false,
    cardShowSize: true,
    previewAccent: "#bbf7d0",
    layoutStyle: "grocery",
  },
  {
    id: "sport-retail",
    name: "Retail",
    tagline: "Bold & editorial — ideal for sportswear, footwear, and lifestyle brands",
    primaryColor: "#111111",
    backgroundColor: "#ffffff",
    headerBackgroundColor: "#ffffff",
    foregroundColor: "#111111",
    font: "sans",
    cardSize: "large",
    cardShowDescription: false,
    cardShowCategory: true,
    cardShowRating: false,
    cardShowSize: false,
    previewAccent: "#f0f0f0",
    layoutStyle: "sport-retail",
  },
];

export function getTemplate(id: TemplateId): TemplatePreset | undefined {
  return TEMPLATES.find((t) => t.id === id);
}

export function templateToSettings(
  t: TemplatePreset,
  isRental = false,
): Partial<StorefrontSettings> {
  return {
    primaryColor: t.primaryColor,
    backgroundColor: t.backgroundColor,
    headerBackgroundColor: t.headerBackgroundColor,
    foregroundColor: t.foregroundColor,
    font: t.font,
    cardSize: t.cardSize,
    cardShowDescription: t.cardShowDescription,
    cardShowCategory: t.cardShowCategory,
    cardShowRating: t.cardShowRating,
    cardShowSize: t.cardShowSize,
    ...(t.layoutStyle ? { layoutStyle: t.layoutStyle } : {}),
    ...(t.layoutStyle === "sport-retail"
      ? { announcementBar: isRental ? "RENTAL SERVICES — SELECT DATES TO BOOK" : "FREE STANDARD DELIVERY ON ORDERS $100+" }
      : {}),
    ...(isRental ? { isRental: true } : {}),
  };
}
